import { IconProps } from '@hawkins/assets';
import { ForwardedRefComponentProps } from '@hawkins/helpers/lib/interfaces';
import { ForwardRefExoticComponent, RefAttributes } from 'react';
import styles from './PseudoIconButton.module.css';
import { Colors } from '@hawkins/variables';

/**
 * A component that acts like a button, but is actually a span with onClick
 * handler and keyboard accessibility.
 * We use this instead of an actual button to avoid issues with nested buttons.
 */
export const PseudoIconButton = ({
  onClick,
  ariaLabel,
  icon: Icon,
}: {
  onClick: (e: React.MouseEvent) => void;
  ariaLabel: string;
  icon: ForwardRefExoticComponent<
    ForwardedRefComponentProps<IconProps> &
      RefAttributes<SVGSVGElement> // Hawkins Icon type
  >;
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onClick(e);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      onClick(e as unknown as React.MouseEvent);
    }
  };

  return (
    <span
      onClick={handleClick}
      role="button"
      tabIndex={0}
      aria-label={ariaLabel}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = Colors.WhiteT10;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = Colors.Transparent;
      }}
      onKeyDown={handleKeyDown}
      className={styles.editFramingDecisionNameButton}
    >
      <Icon className={styles.editFramingDecisionNameButtonIcon} />
    </span>
  );
};
